import React, { useState } from 'react';
import { Heart, MessageCircle, Play } from 'lucide-react';
import { API_URLS } from '../config/api';
import { apiPost } from '../utils/apiUtils';
import { getNovelCoverUrl } from '../utils/novelUtils';
import { t } from '../i18n';
import Modal from './Modal';
import './NovelCard.css';

const NovelCard = ({ novel }) => {
  const [likes, setLikes] = useState(novel.likes || 0);
  const [userHasLiked, setUserHasLiked] = useState(novel.user_has_liked || false);
  const [liking, setLiking] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const handleLike = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (liking) return;
    try {
      setLiking(true);
      const response = await apiPost(API_URLS.PRODUCTION_NOVEL_LIKE(novel.id), {});
      setUserHasLiked(response.data.has_liked);
      setLikes(response.data.likes_count);
    } catch {
      setModalMessage(t('Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт.'));
      setShowModal(true);
    } finally {
      setLiking(false);
    }
  };

  const coverImageUrl = getNovelCoverUrl(novel);

  return (
    <a href={`/production/${novel.play_link}`} className="nc-card">
      <div className="nc-left">
        <div className="nc-cover">
          <img src={coverImageUrl} alt={novel.name} />
        </div>
        <div className="nc-stats">
          <button
            className={`nc-like${userHasLiked ? ' nc-like--active' : ''}`}
            onClick={handleLike}
            disabled={liking}
            style={{ opacity: liking ? 0.5 : 1 }}
          >
            <Heart size="1em" fill={userHasLiked ? 'currentColor' : 'none'} />
            {likes}
          </button>
          <span className="nc-comments">
            <MessageCircle size="1em" />
            {novel.number_of_comments || 0}
          </span>
        </div>
      </div>
      <div className="nc-body">
        <h3 className="nc-title">{novel.name}</h3>
        <p className="nc-desc">{novel.description}</p>
        <div className="nc-play">
          <Play size={16} fill="currentColor" /> {t('Играть')}
        </div>
      </div>

      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title={t('Ошибка')}
        message={modalMessage}
      />
    </a>
  );
};

export default NovelCard;
